import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const LeadsGate = React.lazy(() => import("./Leads.gate"));

const LeadsLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <LeadsGate />
  </React.Suspense>
);

export default () => <LeadsLoadable />;
